import React from 'react'

const Header = () => {
    return (
        <div id="block_container" className="header-container">
            
        </div>
    )
}

export default Header
